import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const RateRowSchema = z.object({
  source: z.enum(["shopify", "redo"]),
  carrier: z.string().nullable(),
  serviceCode: z.string().nullable(),
  serviceName: z.string(),
  priceCents: z.number().int(),
  currency: z.string(),
});

const ResultSchema = z.object({
  destinationCountry: z.string(),
  shopifyStatus: z.enum(["pending", "succeeded", "failed"]),
  shopifyError: z.string().nullable(),
  redoStatus: z.enum(["pending", "succeeded", "failed"]),
  redoError: z.string().nullable(),
  rates: z.array(RateRowSchema),
});

const CartSchema = z.object({
  id: z.string(), // landedCostComparisonCartIdFormat string
  name: z.string(),
  description: z.string(),
  items: z.array(
    z.object({
      productTitle: z.string(),
      sku: z.string().nullable(),
      quantity: z.number().int().positive(),
    }),
  ),
  results: z.array(ResultSchema),
});

export const getLatestLandedCostComparison = {
  name: "getLatestLandedCostComparison" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    run: z
      .object({
        id: z.string(),
        status: z.enum(["pending", "running", "succeeded", "failed"]),
        startedAt: z.date(),
        finishedAt: z.date().nullable(),
        error: z.string().nullable(),
        carts: z.array(CartSchema),
      })
      .nullable(),
  }),
};
